<template>
  <div class="Companyprofile">
      <CompanyprofileTop></CompanyprofileTop>
  </div>
</template>

<script>
import CompanyprofileTop from './CompanyprofileComponents/CompanyprofileTop.vue'
export default {
  components: {
      CompanyprofileTop
  },
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.Companyprofile{
    width: 100%;
    height: 610px;
    background: url("../../../../../assets/channel/homePng/homeCompanyBox.png");
}
</style>